import { PURGE } from 'redux-persist';
import { FORMS, FORMS_FILTER, FORMS_LOADING, RECORDS, RECORDS_FILTERS, RESET_REPORTS } from "../types";


const initialState = {
    forms: [],
    form: null,
    records: [],
    loading: false,
    form_filters: null,
    record_filters: null
}

function forms(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case RESET_REPORTS:
            return initialState
        case PURGE:
            return initialState
        case FORMS:
            return {
                ...state,
                forms: payload
            };
        case RECORDS:
            return {
                ...state,
                records: payload
            };
        case FORMS_LOADING:
            return {
                ...state,
                loading: payload
            };
        case FORMS_FILTER:
            return {
                ...state,
                form_filters: payload
            };
        case RECORDS_FILTERS:
            return {
                ...state,
                record_filters: payload
            };
        default:
            return state;
    }
}

export default forms;